import { observer } from 'mobx-react-lite';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";
import { RootStoreContext } from '../../app/stores/rootStore';
import classNames from 'classnames';

interface IProps {
    isOpen: boolean;
    toggleClose : (expired: boolean) => void;
    logout : (path?:any) => void;
  }

const NearToLogoutForm : React.FC<IProps> = ({ 
  isOpen,
  toggleClose,
  logout 
}) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { user } = rootStore.userStore;
  const [t] = useTranslation(["translation"], translationHookOptions);
  const [cooldown, setCooldown] = useState(60);

  const handleUserAction = useCallback(() => {
    // L'utente ha fatto un'azione, chiudi la modale e chiama il metodo refreshActivity
    console.log("callback")
    toggleClose(true);
  }, [toggleClose]);

  useEffect(() => {
    let countdown: any;

    const handleKeyDown = () => {
      console.log("tasto premuto")
      // Se l'utente preme un tasto qualsiasi sulla tastiera, gestisci l'azione
      handleUserAction();
    };

    if (isOpen) {
      // Inizia il countdown quando la modale si apre
      countdown = setInterval(() => {
        setCooldown((prevCooldown) => prevCooldown - 1);
      }, 1000);

      // Aggiungi event listeners globali
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      // Pulisci il timer e rimuovi gli event listeners quando la modale viene chiusa
      clearInterval(countdown);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, toggleClose, handleUserAction]);

  useEffect(() => {
    // Controlla se il cooldown è scaduto
    if (cooldown === 0) {
      // Chiudi la modale e chiama il metodo di logout
      if (user && user.logoutUrl){
        window.location.assign("/player/logout");
      }else{
      logout();
      }
      toggleClose(false);
    }
  }, [cooldown, toggleClose, logout]);
  

  return (
    <>
    <div>
        <Container >
          <Row>{t("nearToLogoutMessage1")}</Row>
          <Row>{t("nearToLogoutMessage2",{cooldown})}</Row>
          <Row>{t("nearToLogoutMessage3")}</Row>
              {/* La disconnessione avverrà tra ... (countdown). */}
        </Container>
          <Button
          className={classNames( "float-right mr-2 genericButtonClassic",
          // act.color ? 
          `${theme!.buttonSecondaryColor} ${theme!.buttonSecondaryBorderColor} ${theme!.buttonSecondaryTextColor}` 
          // : `${theme!.buttonColor} ${theme!.buttonBorderColor} ${theme!.buttonTextColor}`
        )}
          onClick={() => handleUserAction()}>
            Continua
          </Button>
    </div>
    </>
  );
};

export default observer(NearToLogoutForm);